"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarIncrementor;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _localeLanguageDays = require("./localeLanguageDays");
var _locales = require("../../utils/locales");
var _Icon = _interopRequireDefault(require("../../Icon"));
function CalendarIncrementor(props) {
  const {
    direction,
    calendarIndex,
    numberOfCalendars
  } = props;
  const {
    next_month,
    prev_month
  } = _localeLanguageDays.mobileDatePickerOptions[props.language].nav_controls;
  const isForward = direction === "forward";
  const buttonClass = (0, _classnames.default)({
    "Calendar-incrementor": true,
    "Calendar-incrementor--forward": isForward,
    "is-onlyCalendar": numberOfCalendars === 1,
    "is-firstCalendar": calendarIndex === 0,
    "is-leftAndBefore": calendarIndex % 2 === 0 && !isForward,
    "is-rightAndAfter": calendarIndex % 2 === 1 && isForward
  });
  const iconClass = isForward ? "chevron_right" : "chevron_left";
  return /*#__PURE__*/_react.default.createElement("button", {
    className: buttonClass,
    onClick: event => props.clickHandler(direction),
    "aria-label": isForward ? next_month : prev_month,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: iconClass,
    className: "MonthNavigator-icon"
  }));
}
CalendarIncrementor.propTypes = {
  /** Direction to move calendars, forward/backward */
  direction: _propTypes.default.string.isRequired,
  /** Function called on click, callback is provided the direction as its only argument */
  clickHandler: _propTypes.default.func.isRequired,
  /** Selected user Language */
  language: _propTypes.default.oneOf([_locales.locales.en, _locales.locales.es, _locales.locales.fr, _locales.locales.pt, _locales.locales.zh, _locales.locales.tl, _locales.locales.de, _locales.locales.it, _locales.locales.ko, _locales.locales.ja, _locales.locales.hi]).isRequired
};